module.exports = __webpack_public_path__ + "static/img/mixaves_mijo.4e0a0b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/mixaves_mijo.jpg
// module id = 4puZ
// module chunks = 0